<a [ngClass]="{'disable-anchor': isDisabled(), 'link-color': !isDisabled()}"
   (click)="!isDisabled() && onClickFileName()" class="flex flex-row justify-start items-center"
   particleAnalytics
   analyticsCategory="file-name-cell-viewer"
   [analyticsAction]="item.cells[fieldDefinition.key]?.displayText"
>
  {{item.cells[fieldDefinition.key]?.displayText}}

</a>
